import { useParams, Link } from 'react-router-dom';
import { categories as categoryData } from '@/mocks/categories';
import { articles as articleData } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Helmet from '@/pages/home/components/Helmet';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categoryData.find((c) => c.slug === slug);
  const filteredArticles = articleData.filter((a) => a.category === slug);

  if (!category) {
    return (
      <>
        <ScrollToTop />
        <Navbar />
        <main className="min-h-screen pt-20 flex items-center justify-center">
          <div className="text-center">
            <h1 className="font-heading text-2xl text-foreground-950">分类未找到</h1>
            <Link
              to="/"
              className="mt-4 inline-flex items-center text-primary-500 hover:text-primary-600 whitespace-nowrap"
            >
              <i className="ri-arrow-left-line mr-1"></i>
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Helmet
        title={`${category.name} - 妈妈的朋友们 | 母辈女性友情感悟分享`}
        description={`妈妈的朋友们「${category.name}」栏目：${category.description}。阅读${category.count}篇真实温暖的母辈女性友情故事，感受岁月沉淀下的情感共鸣。`}
        keywords={`妈妈的朋友们${category.name},${category.name}故事,母辈女性友情故事`}
        canonicalUrl={`https://whfwkj666.cn/category/${slug}`}
        ogTitle={`${category.name} - 妈妈的朋友们`}
        ogDescription={`妈妈的朋友们「${category.name}」栏目：${category.description}`}
      />
      <Navbar />
      <main className="min-h-screen pt-20">
        <div className="bg-background-100">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: category.name },
            ]}
          />

          <div className="w-full px-4 md:px-6 py-8 md:py-12">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-8">
                <div className="w-14 h-14 md:w-16 md:h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-500">
                  <i className={`${category.icon} text-2xl`}></i>
                </div>
                <h1 className="mt-4 font-heading text-2xl md:text-3xl text-foreground-950">
                  {category.name}
                </h1>
                <p className="mt-2 text-sm text-foreground-600 max-w-md mx-auto">
                  {category.description}
                </p>
              </div>

              <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
                {categoryData.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className={`px-4 py-2 rounded-full text-sm font-label transition-all duration-200 whitespace-nowrap cursor-pointer ${
                      cat.slug === slug
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-600'
                    }`}
                  >
                    {cat.name}
                  </Link>
                ))}
              </div>

              {filteredArticles.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                  {filteredArticles.map((article) => (
                    <Link
                      key={article.slug}
                      to={`/article/${article.slug}`}
                      className="group block bg-background-50 rounded-lg overflow-hidden hover:shadow-sm transition-all duration-300 cursor-pointer"
                    >
                      <div className="relative w-full h-48 overflow-hidden">
                        <img
                          src={article.coverImage}
                          alt={article.title}
                          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                          loading="lazy"
                        />
                      </div>
                      <div className="p-4 md:p-5">
                        <h3 className="font-heading text-base text-foreground-950 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                          {article.title}
                        </h3>
                        <p className="mt-2 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                          {article.excerpt}
                        </p>
                        <div className="mt-3 flex items-center justify-between text-xs text-foreground-500">
                          <span>{article.date}</span>
                          <span>{article.readTime}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              ) : (
                <div className="text-center py-16">
                  <p className="text-foreground-500">该分类暂无文章</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}